import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config'
import _ from 'lodash'

export async function metaUpdatePages(body) {
    try {
        return await axios.put(`${REACT_APP_API}/integrations/meta/page`, body)
    } catch (error) {
        if (error?.response?.data?.message)
            error.message = error.response.data.message
        throw error
    }
}

export async function metaGetPages() {

    try {
        const res = await axios.get(`${REACT_APP_API}/integrations/metaAccounts`)
        const list = res.data.data
        .map(r => {
            const fullName = r.User ? `${r.User.firstname} ${r.User.lastname}` : "Sin datos";
            return {
                config: r.config,
                fullName
            };
        }).reduce((l, r) => {
            const samePage = l.find(fd => fd.value === r.config.pageId);
            const pageData = {
                value: r.config.pageId,
                label: r.config.name,
                logo: r.config.logo
            };
            if (samePage?.user) {
                return [
                    ...l.filter(f => f.value !== r.config.pageId),
                    {
                        ...pageData,
                        user: [...samePage.user, r.fullName], // Usamos 'firstName' en lugar de 'asofixUserName'
                    }
                ];
            }
            return [
                ...l,
                {
                    ...pageData,
                    user: [r.fullName], // Usamos 'firstName' en lugar de 'asofixUserName'
                }
            ];
        }, []);
        return _.sortBy(list, ['label'])
    } catch (error) {
        if (error?.response?.data?.message)
            error.message = error.response.data.message
        throw error
    }
}
